<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="10">
        <div class="formLabelSemiBoldfs16 mb-5"> {{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement </div>
      </ion-col>
      <ion-col size="2" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <mat-dialog-content class="p-0">
    <form [formGroup]="employeeForm">
      <ion-row>
        <!-- Reimbursement Type -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Reimbursement Type<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select formControlName="reimbursementType" placeholder="Select Type"
              (selectionChange)="onReimbursementTypeChange($event.value)">
              <mat-option [disabled]="data.operation === 'Update'" *ngFor="let type of reimbursementTypesAndIDDD"
                [value]="type.reimbursementId">
                {{ type.reimbursementType }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('reimbursementType', 'required')">This field is required</mat-error>
          </mat-form-field>
        </ion-col>
        <!-- Date of Apply -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Date of Expense<span class="red-cl">*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput [matDatepicker]="picker" 
              formControlName="dateOfExpense" placeholder="Select Date" readonly />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </ion-col>

        <!-- Date of Apply -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Date of Apply<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="dateOfApply" [value]="todayDate" placeholder="Select Date" readonly />
            <mat-error *ngIf="hasError('dateOfApply', 'required')">Date is required</mat-error>
          </mat-form-field>
        </ion-col>

        <!-- Limit of Reimbursement -->
        <ion-col size="12" size-md="4" class="mt-10" *ngIf="setlimitvaue">
          <div class="formLabelRegularfs16 mb-5">Limit of Reimbursement<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="limitOfReimbursement" readonly />
          </mat-form-field>
        </ion-col>

        <!-- Actual Amount -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Actual Amount<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="actualAmount" placeholder="Enter amount" type="text"
              (keydown)="preventNegative($event)" (input)="sanitizeInput($event)" />
            <mat-error *ngIf="hasError('actualAmount', 'required')">Amount is required</mat-error>
          </mat-form-field>
        </ion-col>

        <!-- Actual Amount by Finance -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Actual Amount by Finance</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="amountByFinance" readonly type="number" />
          </mat-form-field>
        </ion-col>

        <!-- Status -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Status</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="status" readonly placeholder="Pending" />
          </mat-form-field>
        </ion-col>

        <!-- Employee Comment -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Employee Comment</div>
          <textarea class="edittextarea w-100 mat-height40 mat-input-style" formControlName="employeeComment"
            maxlength="255" (input)="updateCharCount($event)"></textarea>
          <div class="char-counter">
            {{ charCount }}<span class="backslash">/</span>255
          </div>

        </ion-col>

        <!-- Manager Comment -->
        <ion-col size="12" size-md="4" class="mt-10" *ngIf="approveMatrixValue !== 'EMPLOYEE_TO_FINANCE'">
          <div class="formLabelRegularfs16 mb-5">Manager Comment</div>
          <textarea class="edittextareareadonly w-100 mat-height40 mat-input-style" formControlName="managerComment"
            readonly maxlength="255" (input)="updateCharManagerCount($event)"></textarea>
          <div class="char-counter">{{ charManagerCount }}/255</div>
        </ion-col>

        <!-- Finance Comment -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Finance Comment</div>
          <textarea class="edittextareareadonly w-100 mat-height40 mat-input-style" formControlName="financeComment"
            readonly maxlength="255" (input)="updateCharFinanceCount($event)"></textarea>
          <div class="char-counter">{{ charFinanceCount }}/255</div>
        </ion-col>

        <!-- Document Attachment -->
        <ion-col size="12" size-md="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Document Attachment<span class="red-cl">*</span></div>
          <div *ngIf="this.fileName">
            <span class="cp link" (click)="downloadMisFile(this.fileName)">{{ this.fileName }}</span>
            <img src="./assets/icon/remove.png" class="removeIcon cp" (click)="onRemovemisAttachment()" />
          </div>
          <div *ngIf="!this.fileName" class="mt-0 upload-Contractbox display-center pt-25 pb-25">
            <div class="d-flex">
              <label (click)="browseImage.click()" class="link text_center font_regular cp">Upload Attachment</label>
              <input #browseImage type="file" style="display: none;" (change)="onFileSelected($event)" />
            </div>
            <label class="font_italic fs-14 gray_color">File size should be less than 10MB</label>
          </div>
        </ion-col>
      </ion-row>

      <!-- Buttons -->
      <!-- <ion-row>
        <ion-col size="12" size-md="12" class="text-right mt-10">
          <button (click)="closeDialog()" class="back_btn fs-14">Cancel</button>
          <button (click)="data.operation === 'Add' ? saveEmployeeData() : updateData()"
            [disabled]="!employeeForm.valid || fileName == null" type="button" class="add_btn fs-14 ml-10"
            
            [style.background-color]="buttonColorName" [class.disabled]="employeeForm.invalid || fileName == null">
            {{ data.operation === 'Add' ? 'Add' : 'Update' }}
          </button>
        </ion-col>
      </ion-row> -->
      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button (click)="closeDialog()" class="back_btn fs-14">Cancel</button>
          <button 
            (click)="data.operation === 'Add' ? saveEmployeeData() : updateData()"
            [disabled]="!employeeForm.valid || fileName == null || isSaving"
            type="button"
            class="add_btn fs-14 ml-10"
            [style.background-color]="buttonColorName"
            [class.disabled]="employeeForm.invalid || fileName == null || isSaving">
            {{ data.operation === 'Add' ? 'Add' : 'Update' }}
          </button>
        </ion-col>
      </ion-row>


    </form>
    </mat-dialog-content>

  </div>
  </div>